import { render, staticRenderFns } from "./AddQuestionByProductCodeModal.vue?vue&type=template&id=225c9b62&scoped=true&"
import script from "./AddQuestionByProductCodeModal.vue?vue&type=script&lang=js&"
export * from "./AddQuestionByProductCodeModal.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionByProductCodeModal.vue?vue&type=style&index=0&id=225c9b62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c9b62",
  null
  
)

export default component.exports